import { useEffect } from 'react';

const MOBILE_BREAKPOINT = 768;
const MOBILE_VIEWPORT = [
  'width=650',
  'initial-scale=0.6',
  'minimum-scale=0.3',
  'maximum-scale=3',
  'user-scalable=yes',
  'viewport-fit=cover'
].join(', ');

export default function useMobileViewportZoom() {
  useEffect(() => {
    let viewport = document.querySelector('meta[name="viewport"]');
    const createdViewport = !viewport;

    if (!viewport) {
      viewport = document.createElement('meta');
      viewport.name = 'viewport';
      document.head.appendChild(viewport);
    }

    const originalContent = viewport.getAttribute('content') ||
      'width=device-width, initial-scale=1';

    const updateViewport = () => {
      const isMobile = window.matchMedia(
        `(max-width: ${MOBILE_BREAKPOINT}px)`
      ).matches;

      viewport.setAttribute(
        'content',
        isMobile ? MOBILE_VIEWPORT : originalContent
      );
      document.documentElement.classList.toggle(
        'mobile-default-zoom-60',
        isMobile
      );
    };

    updateViewport();
    window.addEventListener('resize', updateViewport);
    window.addEventListener('orientationchange', updateViewport);

    return () => {
      window.removeEventListener('resize', updateViewport);
      window.removeEventListener('orientationchange', updateViewport);
      document.documentElement.classList.remove('mobile-default-zoom-60');

      if (createdViewport) {
        viewport.remove();
      } else {
        viewport.setAttribute('content', originalContent);
      }
    };
  }, []);
}
